import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading text-background-50 mb-4">韩漫屋</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫屋是官方认证的韩漫官网站，提供权威的韩漫大全与好看韩国漫画免费在线观看。每日更新最新章节，为漫画爱好者打造优质的在线漫画阅读平台。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">全部漫画</Link></li>
              <li><Link to="/category/hot" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">热门推荐</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">动作漫画</Link></li>
              <li><Link to="/category/suspense" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">悬疑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-primary-400"></i>
                service@hanmanwu.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-customer-service-line text-primary-400"></i>
                在线客服：工作日 9:00-18:00
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-primary-400"></i>
                韩国首尔特别市江南区
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 韩漫屋 HanManWu.com 版权所有 | 韩漫大全 好看韩国漫画 免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}